
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    data: Object
  },
  data() {
    return {
      reachable: '#70d16b',
      unreachable: '#f87051',
      unkown: '#808080'
    }
  },
  methods: {
    stateColor(state: string) {
      if (state?.toLowerCase().trim() == 'ok') {
        return this.reachable
      } else if (state?.toLowerCase().trim() == 'unreachable') {
        return this.unreachable
      } else {
        return this.unkown
      }
    },
    stateName(state: string) {
      if (state?.toLowerCase().trim() == 'unreachable') {
        return 'injoignable'
      } else if (state?.toLowerCase().trim() == 'ok') {
        return 'connecté'
      } else {
        return 'inconnu'
      }
    }
  }
})
